import { reactive } from '@vue/reactivity'

const state = reactive({
    canSubmit: true,
    loading: false,
    content: '',
    step: 0,
    formErrors: {},
    formData: {},
    usesFlexibleJourney: window.__STATE?.webForm?.usesFlexibleJourney === true,
})

const stateManager = new class {

    get canSubmit() {
        return state.canSubmit
    }

    set canSubmit(value) {
        state.canSubmit = value
    }

    get loading() {
        return state.loading
    }

    set loading(value) {
        state.loading = value
    }

    get webFormContent() {
        return state.content
    }

    set webFormContent(value) {
        state.content = value
    }

    set step(value) {
        state.step = value
    }

    get step() {
        return state.step
    }

    get formErrors() {
        return state.formErrors
    }

    set formErrors(value) {
        state.formErrors = value ?? {}
    }

    get formData() {
        return state.formData
    }

    set formData(value) {
        state.formData = value
    }

    get usesFlexibleJourney() {
        return state.usesFlexibleJourney
    }

    set usesFlexibleJourney(value) {
        state.usesFlexibleJourney = value
    }

    incrementStep() {
        state.step++
    }

    hasErrors(fieldName) {
        return state.formErrors[ fieldName ]?.length
    }

    firstError(fieldName) {

        const errors = state.formErrors[ fieldName ] || []

        if (!errors.length) {
            return ''
        }

        return errors[ 0 ]

    }

    visibleErrorFieldPatterns() {

        if (typeof document === 'undefined') {
            return []
        }

        return Array.from(document.querySelectorAll('[data-form-error-field]'))
            .map(element => element.dataset.formErrorField)
            .filter(Boolean)

    }

    matchesFieldPattern(fieldName, pattern) {

        if (!pattern.includes('*')) {
            return fieldName === pattern
        }

        const fieldSegments = fieldName.split('__dot__')
        const patternSegments = pattern.split('__dot__')

        if (fieldSegments.length !== patternSegments.length) {
            return false
        }

        return patternSegments.every((segment, index) => (
            segment === '*'
            || segment === fieldSegments[ index ]
        ))

    }

    hiddenErrorEntries() {

        const visiblePatterns = this.visibleErrorFieldPatterns()

        return Object.entries(state.formErrors)
            .filter(([ fieldName ]) => (
                !visiblePatterns.some(pattern => this.matchesFieldPattern(fieldName, pattern))
            ))
            .map(([ fieldName, messages ]) => ({ fieldName, messages }))

    }

    hasHiddenErrors() {
        return this.hiddenErrorEntries().length > 0
    }

    hiddenErrorFieldNames() {

        return Array.from(new Set(
            this.hiddenErrorEntries()
                .map(({ fieldName }) => this.displayHiddenErrorFieldName(fieldName))
                .filter(Boolean),
        ))

    }

    displayHiddenErrorFieldName(fieldName) {

        const segments = fieldName.split('__dot__')

        if (!segments.length) {
            return ''
        }

        const [ firstSegment, ...remainingSegments ] = segments

        const displaySegments = /^\d+:\d+$/.test(firstSegment)
            ? remainingSegments
            : [ firstSegment, ...remainingSegments ]

        return displaySegments.join('.')

    }

    reset() {

        const usesFlexibleJourney = state.usesFlexibleJourney

        state.canSubmit = true
        state.loading = false
        state.formErrors = {}
        state.formData = {}
        state.usesFlexibleJourney = usesFlexibleJourney

    }

}()

export default stateManager
